import colors from "../lib/colors.json";

const useColor = () => {
  const colorNames = Object.keys(colors);
  const useableColors = colorNames.filter((c) => colors[c].page_color);
  const colorName = useableColors[Math.floor(Math.random() * useableColors.length)];
  const color = colors[colorName];
  return [colorName, color.hex];
};

export default useColor;
